<template>
    <div class="expenses">
        <div class="content">
            <div class="wrap">
                <div class="wrap__tree">
                    <div class="nav-tree">
                        <el-radio disabled @change="stateChange" v-model="activeState" size="mini" label="businessUnitTaskVendorInvoice" border>Business Units</el-radio>
                        <el-radio disabled @change="stateChange" v-model="activeState" size="mini" label="engagementTaskVendorInvoice" border>Engagements</el-radio>
                        <el-radio @change="stateChange" v-model="activeState" size="mini" label="projectTaskVendorInvoice" border>Projects</el-radio>
                        <!--<el-select class="inputs" no-data-text="no data" v-model="projectId" :placeholder="labelName" size="mini">-->
                            <!--<el-option-->
                                    <!--v-for="item in projects"-->
                                    <!--:key="item.id"-->
                                    <!--:label="item.name"-->
                                    <!--:value="item.id"-->
                                    <!--@click.native="setValueProjectAfterSubmit(item.id, activeState)">-->
                            <!--</el-option>-->
                        <!--</el-select>-->
                    </div>
                    <div class="nav-tree">
                        <el-button v-if="activeTab === 'journalEntry'" @click="openModalCreateJournalEntry(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">Create Journal Entry</el-button>
                        <el-button v-else @click="openModal(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">Create Vendor Invoice</el-button>
                    </div>
                    <el-tabs v-model="activeTab" type="card" @tab-click="handleClickMainTabs">
                        <el-tab-pane name="journalEntry" label="Journal Entry">
                            <el-table
                                    :data="journalEntryList"
                                    style="width: 100%"
                                    :cell-class-name="cellClassName"
                                    :row-class-name="tableRowClassName"
                                    :header-cell-class-name="headerCellClassName"
                                    @cell-click="cellClickJournalEntry">
                                <el-table-column
                                        type="index"
                                        width="50">
                                </el-table-column>
                                <el-table-column
                                        label="Journal Date"
                                        width="100">
                                    <template slot-scope="scope">
                                        {{moment(scope.row.journalDate).format('D MMM YY')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Document Date"
                                        width="120">
                                    <template slot-scope="scope">
                                        {{moment(scope.row.documentDate).format('D MMM YY')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Currency"
                                        width="100">
                                    <template slot-scope="scope">
                                        {{scope.row.currency.name}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Event Date"
                                        width="120">
                                    <template slot-scope="scope">
                                        {{moment(scope.row.eventDate).format('D MMM YY')}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Source Ref."
                                        width="120">
                                    <template slot-scope="scope">
                                        {{scope.row.sourceRef}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Description">
                                    <template slot-scope="scope">
                                        {{scope.row.description}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Debit"
                                        width="120">
                                    <template slot-scope="scope">
                                        {{formatPrice(scope.row.totalDebit)}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="Credit"
                                        width="120">
                                    <template slot-scope="scope">
                                        {{formatPrice(scope.row.totalCredit)}}
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <!--<el-tab-pane name="vendorInvoice" label="Vendor Invoice">-->
                            <!--<el-table-->
                                    <!--:data="vendorInvoiceList"-->
                                    <!--style="width: 100%"-->
                                    <!--:cell-class-name="cellClassName"-->
                                    <!--:row-class-name="tableRowClassName"-->
                                    <!--:header-cell-class-name="headerCellClassName"-->
                                    <!--@cell-click="cellClickVendorInvoice">-->
                                <!--<el-table-column-->
                                        <!--type="index"-->
                                        <!--width="50">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="No."-->
                                        <!--prop="vendorInvoice.code"-->
                                        <!--width="100">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--:label="labelName"-->
                                        <!--width="180">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<div v-if="scope.row.project">-->
                                            <!--{{scope.row.project.name}}-->
                                        <!--</div>-->
                                        <!--<div v-if="scope.row.engagement">-->
                                            <!--{{scope.row.engagement.name}}-->
                                        <!--</div>-->
                                        <!--<div v-if="scope.row.businessUnit">-->
                                            <!--{{scope.row.businessUnit.name}}-->
                                        <!--</div>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Task"-->
                                        <!--width="180">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<div v-if="scope.row.projectTask">-->
                                            <!--{{scope.row.projectTask.name}}-->
                                        <!--</div>-->
                                        <!--<div v-if="scope.row.engagement">-->
                                            <!--{{scope.row.engagementTask.name}}-->
                                        <!--</div>-->
                                        <!--<div v-if="scope.row.businessUnit">-->
                                            <!--{{scope.row.businessUnitTask.name}}-->
                                        <!--</div>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Date"-->
                                        <!--width="110">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<div v-if="scope.row.vendorInvoice.date">-->
                                            <!--{{moment(scope.row.vendorInvoice.date.toString(), 'x').format('D MMM YY')}}-->
                                        <!--</div>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Due Date"-->
                                        <!--width="120">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<div v-if="scope.row.vendorInvoice.dueDate">-->
                                            <!--{{moment(scope.row.vendorInvoice.dueDate.toString(), 'x').format('D MMM YY')}}-->
                                        <!--</div>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--prop="vendorInvoice.vendor.name"-->
                                        <!--label="Vendor"-->
                                        <!--width="140">-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Total Amount"-->
                                        <!--width="140">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<div v-if="scope.row.vendorInvoice.totalAmount">-->
                                            <!--{{formatPrice(scope.row.vendorInvoice.totalAmount)}}-->
                                        <!--</div>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--prop="status"-->
                                        <!--label="Payment Status"-->
                                        <!--width="130">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<el-button v-if="scope.row.vendorInvoice.paymentStatus === 1"-->
                                                   <!--size="mini"-->
                                                   <!--type="primary"-->
                                                   <!--plain>-->
                                            <!--Pending-->
                                        <!--</el-button>-->
                                        <!--<el-button v-if="scope.row.vendorInvoice.paymentStatus === 2"-->
                                                   <!--size="mini"-->
                                                   <!--type="success"-->
                                                   <!--plain>-->
                                            <!--Partially Received-->
                                        <!--</el-button>-->
                                        <!--<el-button v-if="scope.row.vendorInvoice.paymentStatus === 3"-->
                                                   <!--size="mini"-->
                                                   <!--type="success"-->
                                                   <!--plain>-->
                                            <!--Paid-->
                                        <!--</el-button>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                                <!--<el-table-column-->
                                        <!--label="Operations"-->
                                        <!--width="200">-->
                                    <!--<template slot-scope="scope">-->
                                        <!--<el-button-->
                                                <!--v-if="scope.row.vendorInvoice.paymentStatus === 1"-->
                                                <!--size="mini"-->
                                                <!--type="primary"-->
                                                <!--plain-->
                                                <!--icon="el-icon-edit"-->
                                                <!--@click="handleEdit(scope.$index, scope.row, activeState)"></el-button>-->
                                    <!--</template>-->
                                <!--</el-table-column>-->
                            <!--</el-table>-->
                        <!--</el-tab-pane>-->
                    </el-tabs>
                    <!--{{journalEntryList}}-->
                </div>
            </div>
        </div>


        <!--VENDOR INVOICE INFO MODAL-->
        <vendorRequestInvoiceInfoModal ref="vendorRequestInvoiceInfoModal"/>
        <!--VENDOR INVOICE INFO MODAL-->

        <!--VENDOR INVOICE INFO MODAL-->
        <journalEntryInfoModal ref="journalEntryInfoModal"/>
        <!--VENDOR INVOICE INFO MODAL-->

        <!--VENDOR INVOICE MODAL CREATE-->
        <createJournalEntryModal :selectedRow="selectedRow" @refreshJournalList='setValueProjectAfterSubmitModal' ref="createJournalEntryModal"/>
        <!--VENDOR INVOICE MODAL CREATE-->

        <!--VENDOR INVOICE MODAL CREATE-->
        <createVendorInvoiceModal :selectedRow="selectedRow" @setValueProject='setValueProjectAfterSubmitModal' ref="createVendorInvoiceModal"/>
        <!--VENDOR INVOICE MODAL CREATE-->

        <!--VENDOR INVOICE MODAL EDIT-->
        <editVendorInvoiceModal :selectedRow="selectedRow" @setValueProject='setValueProjectAfterSubmitModal' ref="editVendorInvoiceModal"/>
        <!--VENDOR INVOICE MODAL EDIT-->

        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  import projectExpenseModal from '@/components/Projects/projectExpenseModal.vue'
  import journalEntryInfoModal from '@/components/journalAndGl/journalEntryInfoModal.vue'
  import vendorRequestInvoiceInfoModal from '@/components/vendorInvoices/vendorRequestInvoiceInfoModal.vue'
  import createJournalEntryModal from '@/components/journalAndGl/createJournalEntryModal.vue'
  import createVendorInvoiceModal from '@/components/vendorInvoices/createVendorInvoiceModal.vue'
  import editVendorInvoiceModal from '@/components/vendorInvoices/editVendorInvoiceModal.vue'



  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Media from '@dongido/vue-viaudio'
  export default {
    name: 'journal-and-gl',
    components: {
      SweetModal,
      projectExpenseModal,
      journalEntryInfoModal,
      vendorRequestInvoiceInfoModal,
      createVendorInvoiceModal,
      createJournalEntryModal,
      editVendorInvoiceModal,
      Media
    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    mounted(){
      this.getProjects(this.activeState)
    },
    data() {
      return {
        activeTab: 'journalEntry',
        labelName: 'Project',
        activeState: 'projectTaskVendorInvoice',
        projectId: '',
        projects:[],
        selectedRow:{},
        journalEntryList:[],
        vendorInvoiceList:[],
        moment:moment,
        companyNameSelect: '',
        slectedRowId: '',
        fileUrl: '',
        type: '',
        viewerType: '',
        allowMyProjectTaskExpenseList:true,
        allowProjectTaskExpenseList:true,
        activeCompanyId: '',
        activeProjectId: '',
        activeTaskId: '',
        activeExpenseId: '',
        description: '',
        isLeader: false,
        createTimestamp: '',
      }
    },
    methods: {
      stateChange(state){
        this.getProjects(state)
      },
      getProjects(state){
        let myState = '';
        switch (state){
          case 'projectTaskVendorInvoice':
            this.projects = [{name: 'All Projects', id: 'all'}]
            myState = 'projects';
            break;
          case 'engagementTaskVendorInvoice':
            this.projects = [{name: 'All Engagements', id: 'all'}]
            myState = 'engagements';
            break;
          case 'businessUnitTaskVendorInvoice':
            this.projects = [{name: 'All Business Units', id: 'all'}]
            myState = 'businessUnits';
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.projects =  this.projects.concat(response.data.list)
            this.projectId = this.projects[0].id
            // this.checkStatus(this.projectId)
            this.setValueProjectAfterSubmit(this.projectId, state)
          }).catch(error =>{

        })
      },
      openModalAsk(){
        this.$refs['askBefore'].open()
      },
      refreshVendorInvoiceRequest(){
        this.setValueProjectAfterSubmit(this.projectId, this.activeState)
      },
      setValueProjectAfterSubmit(projectId, state){
        if(projectId === 'all'){
          this.setValueProjectAll(state)
        }else{
          this.setValueProject(projectId, state)
        }
      },
      setValueProjectAfterSubmitModal(projectId){
        if(this.projectId === 'all'){
          this.setValueProjectAll(this.activeState)
        }else{
          this.setValueProject(projectId, this.activeState)
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      setValueProject(projectId, state){

        const urlParts = this.buildUrl(state, false);
        console.log('urlParts', urlParts);
        this.projectId = projectId;
        let loader = this.$loading.show();
        this.$router.push(`/journal-and-gl?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/${urlParts.myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            switch(this.activeTab){
              case 'journalEntry':
                this.journalEntryList = response.data.list;
                break;
              case 'vendorInvoice':
                this.vendorInvoiceList = response.data.list;
                break;
            }
          }).catch(error =>{
          loader.hide()
        })
      },
      setValueProjectAll(state){
        const urlParts = this.buildUrl(state, false);
        console.log('urlParts', urlParts);
        // this.projectId = projectId
        let loader = this.$loading.show();
        this.$router.push(`/journal-and-gl?companyId=${this.$route.query.companyId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/${urlParts.myState}/list?companyId=${this.$route.query.companyId}&type=${urlParts.type}`)
          .then(response => {
            switch(this.activeTab){
              case 'journalEntry':
                this.journalEntryList = response.data.list;
                break;
              case 'vendorInvoice':
                this.vendorInvoiceList = response.data.list;
                break;
            }
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      handleEdit(index, row, state){
        console.log('row', row);
        const urlParts = this.buildUrl(state, row);
        this.$refs['editVendorInvoiceModal'].openModalEdit(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.vendorInvoiceId, urlParts.type, 'user')
      },
      handleClickMainTabs(tab, event){
        if(this.projectId === 'all'){
          this.setValueProjectAll(this.activeState, tab.name)
        }else{
          this.setValueProject(this.projectId, this.activeState, tab.name)
        }
      },
      handleClickTabs(tab, event){
        switch (tab.name){
          case 'addedExpensesMyList':
            this.setValueProjectAfterSubmit(this.projectId);
            break;
          case 'addedExpensesProjectList':
            this.setValueProjectAfterSubmit(this.projectId);
            break;
          case 'requestExpensesMyList':
            alert('requestExpensesMyList');
            break;
          case 'requestExpensesProjectList':
            alert('requestExpensesProjectList');
            break
        }
      },
      handleSubmit(index, row, state) {

        const urlParts = this.buildUrl(state, row);
        console.log('urlParts', urlParts);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/submit?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateExpenseId}=${row.id}`)
          .then(response => {
            this.notification("Success", "Submit Expense", "success")
            this.setValueProjectAfterSubmit(this.projectId, this.activeState)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
        console.log(index, row)
      },
      handleDelete(index, row, state){
        console.log('rowId', row)
        const urlParts = this.buildUrl(state, row)
        console.log('urlParts', urlParts)
        this.selectedRowId = row.vendorInvoiceId

        this.$confirm('This will permanently delete the Request Vendor Invoice. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/${urlParts.myState}/delete?id=${row.vendorInvoiceId}`)
            .then(response => {
              this.setValueProjectAfterSubmit(this.projectId, state);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      handleOrder(index, row, state){
        console.log('index', index)
        console.log('row', row)
        console.log('state', state)
        this.$confirm('Create Purchase Order from Purchase Request. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          let type = ''
          if(row.projectTaskId){
            type = 'projectTask'
          }else if(row.projectId){
            type = 'project'
          }else if(row.engagementTaskId){
            type = 'engagementTask'
          }else if(row.engagementId){
            type = 'engagement'
          }else if(row.businessUnitTaskId){
            type = 'businessUnitTask'
          }else if(row.businessUnitId){
            type = 'businessUnit'
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/purchaseOrder/createFromRequest?type=${type}&id=${row.purchaseRequestId}`)
            .then(response => {
              this.setValueProjectAfterSubmit(this.projectId, state);
              this.$message({
                type: 'success',
                message: 'Delete completed'
              });
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled'
          });
        });
      },
      handleShowImg(index, row, state){
        const urlParts = this.buildUrl(state, row);
        console.log(index, row);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/fieldInfo?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}}&${urlParts.stateExpenseId}=${row.id}&field=file`)
          .then(response => {
            this.viewFile(response.data.fieldInfo.url)
          })
          .catch(error => {
            // this.$refs.confirmation.close()
            console.log('An error occurred:', error);
          });
      },
      viewFile(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          this.fileUrl = url
          this.type = this.fileUrl.split('.').pop().toUpperCase()
          console.log('---', this.fileUrl, this.type);

          if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (this.type == 'OGG' || this.type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }
        }
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      closeMod() {
        this.viewerType = 0;
      },
      cellClickVendorInvoice(row, column, event){
        console.log('row', row);
        // if(column.label !== 'File' && column.label !== 'Operations'){
        //   const urlParts = this.buildUrl(this.activeState, row);
        //   this.$refs.journalEntryInfoModal.openModalInfo(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.vendorInvoiceId, urlParts.type, 'user');
        // }
      },
      cellClickJournalEntry(row, column, event){
        console.log('row', row);
        this.$refs.journalEntryInfoModal.openModalInfo(row)
        // if(column.label !== 'File' && column.label !== 'Operations'){
        //   const urlParts = this.buildUrl(this.activeState, row);
        //   this.$refs.vendorRequestInvoiceInfoModal.openModalInfo(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.vendorInvoiceId, urlParts.type, 'user');
        // }
      },
      openModalCreateJournalEntry(state){
        const urlParts = this.buildUrl(state);
        console.log('urlParts', urlParts);
        this.$refs['createJournalEntryModal'].openModalFromJournalAndGl(urlParts.type)
      },
      openModal(state) {
        const urlParts = this.buildUrl(state);
        this.$refs['createVendorInvoiceModal'].openModalFromVendorInvoice(urlParts.type)
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      buildUrl(state, row, activeTab) {
        console.log('state',  state, 'row', row)
        let myState = '';
        let stateProjectId = '';
        let stateTaskId = '';
        let projectId = '';
        let taskId = '';
        let type ='';
        switch(this.activeTab){
          case 'journalEntry':
            if (state === 'projectTaskVendorInvoice') {
              myState = 'journalEntry';
              stateProjectId = 'projectId';
              stateTaskId = 'projectTaskId';
              type = 'project';
              if(row){
                projectId = row.projectId;
                taskId = row.projectTaskId;
                // type = !taskId ? 'project' : 'projectTask'
                type = 'project'
              }
            } else if (state === 'engagementTaskVendorInvoice') {
              myState = 'journalEntry';
              stateProjectId = 'engagementId';
              stateTaskId = 'engagementTaskId';
              type = 'engagement';
              if(row){
                projectId = row.engagementId;
                taskId = row.engagementTaskId;
              }
            } else if (state === 'businessUnitTaskVendorInvoice') {
              myState = 'journalEntry';
              stateProjectId = 'businessUnitId';
              stateTaskId = 'businessUnitTaskId';
              type = 'business-unit';
              if(row){
                projectId = row.businessUnitId
                taskId = row.businessUnitTaskId
              }
            }
            break;
          case 'vendorInvoice':
            if (state === 'projectTaskVendorInvoice') {
              myState = 'vendorInvoice';
              stateProjectId = 'projectId';
              stateTaskId = 'projectTaskId';
              type = 'project';
              if(row){
                projectId = row.projectId;
                taskId = row.projectTaskId;
                // type = !taskId ? 'project' : 'projectTask'
                type = 'project'
              }
            } else if (state === 'engagementTaskVendorInvoice') {
              myState = 'vendorInvoice';
              stateProjectId = 'engagementId';
              stateTaskId = 'engagementTaskId';
              type = 'engagement';
              if(row){
                projectId = row.engagementId;
                taskId = row.engagementTaskId;
              }
            } else if (state === 'businessUnitTaskVendorInvoice') {
              myState = 'vendorInvoice';
              stateProjectId = 'businessUnitId';
              stateTaskId = 'businessUnitTaskId';
              type = 'business-unit';
              if(row){
                projectId = row.businessUnitId;
                taskId = row.businessUnitTaskId
              }
            }
            break
        }
        return {
          myState: myState,
          stateProjectId: stateProjectId,
          stateTaskId: stateTaskId,
          projectId: projectId,
          taskId: taskId,
          type: type
        }
      }
    },
    watch:{
      // purchaseListRequest(val){
      //   val.forEach(i =>{
      //     if(i.purchaseRequest.orderDate) {
      //       i.purchaseRequest.orderDate = moment(i.purchaseRequest.orderDate.toString(), 'X').format('DD MMM YYYY')
      //     }
      //   })
      // },
      vendorInvoiceList(val){
        val.forEach(i =>{
          if(i.vendorInvoice.date){
            i.vendorInvoice.date = moment(i.vendorInvoice.date.toString(), 'x').format('DD MMM YYYY')
          }
          if(i.vendorInvoice.dueDate){
            i.vendorInvoice.dueDate = moment(i.vendorInvoice.dueDate.toString(), 'x').format('DD MMM YYYY')
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .expenses{
        background: #fff;
    }

    .content {
        display: flex;
        min-height: 100vh;
        padding-top: 50px;
    }

    // [ Wrapper ] start
    .wrap {
        display: flex;
        justify-content:center;
        width: 100%;
        padding: 20px 10px 10px 10px;

        &__tree {
            max-width: 1500px;
            width:100%;
            padding: 0 0 10px 0;
        }
        &.animation{
            margin-left:260px;
            transition: margin-left 500ms ease-out, transform 500ms ease-out;
        }
    }
    // [ Wrapper ] end

    // [ Nav tree ] start
    .nav-tree {
        padding-bottom: 10px;
        &__item {
            margin: 0 0 5px 0;
            &_btn{
                /*margin-left:10px;*/
            }
        }
        .el-button {
            margin-right: 10px;
        }
        .el-radio{
            margin-right:0;
        }
        .inputs{
            margin-left:10px;
        }
    }
    // [ Nav tree ] end

    // [ Modal ] start
    .button{
        cursor: pointer;
    }
    // [ Modal ] end
    .modal__title{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .history-block{
        height:300px;
        overflow-y: auto;
    }
    .history-item-block{
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
    }
    .modal__amount{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .iframe{
        width:640px;
        height:700px;
    }
    .modal__bottom{
        margin-top:20px;
    }
    .modal__history_btn_block{
        margin-top:20px;
    }
    .menu{
        min-height:calc(100vh - 50px);
    }
    .menu.animation{
        position: fixed;
    }
    /deep/.el-upload{
        width:100%;
    }
    /deep/.el-upload-dragger{
        min-width:100%;
    }
</style>
